import IndustriesContainer from './industries_container';

const Industries = IndustriesContainer;
export default Industries;
